import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Table, Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Aside from '../../components/Aside';
import { ORG_ALL, USER_CREATE, USER_DELETE, USER_DETAIL, USER_LIST, USER_UPDATE, fetchData } from '../../components/Service';
import { displayError } from '../../components/Helper';
import { Context } from '../../components/Context';

const Users = () => {
    const [listLoader, setListLoader] = useState(false)
    const [tinyLoader, setTinyLoader] = useState(false)

    const [context] = useContext(Context)

    const [userList, setUserList] = useState([])
    const [userData, setUserData] = useState()
    const [orgList, setOrgList] = useState([])
    const [orgId, setOrgId] = useState();

    const [Modal1, setModal1] = useState(false);
    const [Modal2, setModal2] = useState(false);

    const handleClose1 = () => setModal1(false);
    const handleShow1 = () => setModal1(true);
    const handleClose2 = () => setModal2(false);
    const handleShow2 = () => setModal2(true);

    const getUsersList = (e) => {
        setListLoader(true);

        fetchData(`${USER_LIST}?type=user&orgId=${orgId}`, 'GET', "", true, false, (res) => {
            setListLoader(false);
            if (res.status === "success") {
                setUserList(res.records)
            } else {
                // displayError(res.errors)
            }
        });
    }

    const saveData = (e, type) => {
        let formData = new FormData(document.getElementById(type + '-user'));
        
        let data = {
            id: userData && userData.id,
            orgId:  formData.get("orgId"),
            firstName:  formData.get("firstName"),
            lastName:  formData.get("lastName"),
            userName:  formData.get("userName"),
            phone:  formData.get("phone"),
            email:  formData.get("email"),
            password:  formData.get("password"),
        }

        setTinyLoader(type)

        fetchData(type === "update" ? USER_UPDATE : USER_CREATE, 'POST', data, true, false, (res) => {
            setTinyLoader(false);

            if (res.status === "success") {
                handleClose1()
                handleClose2()
                getUsersList()
            } else {
                displayError(res.errors)
            }
        });
    }

    const getUser = (id) => {
        setTinyLoader("edit");

        fetchData(USER_DETAIL + "/" + id, 'GET', "", true, false, (res) => {
            setTinyLoader(false);
            if (res.status === "success") {
                setUserData(res.records)
                handleShow2()
            } else {
                // displayError(res.errors)
            }
        });
    }

    const deleteUser = (id) => {
        setTinyLoader("delete");

        fetchData(USER_DELETE + "/" + id, 'DELETE', "", true, false, (res) => {
            setTinyLoader(false);
            if (res.status === "success") {
                getUsersList()
            } else {
                // displayError(res.errors)
            }
        });
    }

    const getOrgList = (e) => {
        setListLoader(true);

        fetchData(ORG_ALL, 'GET', "", true, false, (res) => {
            setListLoader(false);
            if (res.status === "success") {
                setOrgList(res?.records)
                setOrgId(res?.records[0]?.id)
            } else {
                // displayError(res.errors)
            }
        });
    }

    useEffect(() => {
        getOrgList()
    }, [])

    useEffect(() => {
        if(orgId) {
            getUsersList()
        }
    }, [orgId])

    return (
        <>
        <div className="dashboard-content-block">
            <div className="dashbaord-heading">
                Users
            </div>
            <div className="user-table-block">
                <div className="create-user-block">
                    {context?.role == "admin" && <div className="select-dsp-block">
                        <Form.Group className="form-group">
                            <Form.Label>Select Organization</Form.Label>
                            <Form.Select onChange={(e) => setOrgId(e.target.value)}>
                                {orgList && orgList.length && orgList.map((item, i) => (
                                    <option value={item.id} selected={orgId == item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>}
                    <Button variant="primary" onClick={handleShow1}>Create User</Button>
                </div>
                <Table responsive bordered hover>
                    <thead>
                        <tr>
                            <th width="20px" className="text-center">#</th>
                            <th>Name</th>
                            <th>Email Id</th>
                            <th width="150px">Phone Number</th>
                            <th>Username</th>
                            <th width="100px" className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userList && userList.length ? userList.map((user, i) => (
                            <tr key={user.id}>
                                <td className="text-center">{user.id}</td>
                                <td>{user.firstName} {user.lastName}</td>
                                <td>{user.email}</td>
                                <td>{user.phone}</td>
                                <td>{user.userName}</td>
                                <td className="text-center">
                                    <Button variant="edit" onClick={(e) => getUser(user.id)}><FontAwesomeIcon icon="fa-solid fa-pencil" /></Button>
                                    <Button variant="delete" onClick={(e) => deleteUser(user.id)} disabled={tinyLoader === "delete"}>{ tinyLoader === "delete" ? <Spinner animation="grow" size="sm" /> : <FontAwesomeIcon icon="fa-solid fa-trash-can" /> }</Button>
                                </td>
                            </tr>
                        )) : <tr><td colSpan="6" className='text-center text-danger'>No User Found</td></tr>}
                    </tbody>
                </Table>
            </div>
        </div>

        <Modal centered show={Modal1} onHide={handleClose1} className="custom-dashboard-model" key="1">
            <Modal.Header closeButton>
            <Modal.Title>Create User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="create-user">
                    <Row>
                        {context?.role == "admin" && <Col lg={12}>
                            <Form.Group className="form-group">
                                <Form.Label>Select Status</Form.Label>
                                <Form.Select name="orgId">
                                    <option value="">
                                        Select an organization
                                    </option>
                                    {orgList && orgList.length && orgList.map((item, i) => (
                                        <option value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>}
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>First Name *</Form.Label>
                                <Form.Control type="text" name="firstName"/>
                                <span id="form-error-firstName" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control type="text" name="lastName"/>
                                <span id="form-error-lastName" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email Id *</Form.Label>
                                <Form.Control type="email" name="email"/>
                                <span id="form-error-email" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Phone Number *</Form.Label>
                                <Form.Control type="text" name="phone"/>
                                <span id="form-error-phone" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Username *</Form.Label>
                                <Form.Control type="text" name="userName"/>
                                <span id="form-error-userName" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Password *</Form.Label>
                                <Form.Control type="text" name="password"/>
                                <span id="form-error-password" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="dash-buttons-block">
                        <Button variant="primary" onClick={(e) => saveData(e, 'create')} disabled={tinyLoader === "create"}>{ tinyLoader === "create" && <Spinner animation="grow" size="sm" /> } Add user</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal centered show={Modal2} onHide={handleClose2} className="custom-dashboard-model" key="2">
            <Modal.Header closeButton>
            <Modal.Title>Edit User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="update-user">
                    <Row>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>First Name *</Form.Label>
                                <Form.Control type="text" name="firstName" defaultValue={userData && userData.firstName}/>
                                <span id="form-error-firstName" className='form-input-error'></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control type="text" name="lastName" defaultValue={userData && userData.lastName}/>
                                <span id="form-error-lastName" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email Id *</Form.Label>
                                <Form.Control type="email" name="email" defaultValue={userData && userData.email}/>
                                <span id="form-error-email" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Phone Number *</Form.Label>
                                <Form.Control type="text" name="phone" defaultValue={userData && userData.phone}/>
                                <span id="form-error-phone" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Username *</Form.Label>
                                <Form.Control type="text" name="userName" defaultValue={userData && userData.userName}/>
                                <span id="form-error-userName" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Password *</Form.Label>
                                <Form.Control type="text" name="password"/>
                                <span className='small text-muted'>Leave it blank, if do not want to change.</span>
                                <span id="form-error-password" className='form-input-error' ></span>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="dash-buttons-block">
                        <Button variant="primary" onClick={(e) => saveData(e, 'update')} disabled={tinyLoader === "update"}>{ tinyLoader === "update" && <Spinner animation="grow" size="sm" /> } Edit user</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
        </>
    );
};

export default Users;
